<template>
  <div>
    <navbar />
    <router-view :key="key" />
    <Footer />
  </div>
</template>

<script>
import Navbar from "./Navbar";
import Footer from "./Footer";

export default {
  name: "Layout",
  components: { Navbar, Footer },
  computed: {
    key() {
      return this.$route.path;
    }
  }
};
</script>